import React from "react";

import LegalDocument from "../legal_document";
import legalPrivacy from "../content/legal_privacy";

const PrivacyPolicy = () => <LegalDocument layout={legalPrivacy} />;

export default PrivacyPolicy;
